import { createStore } from "vuex";
import language from "./language";
import admin from "./admin";
import client from "./client";
import yellow from "./yellow";

export default createStore({
  namespaced: true,
  modules: {
    language,
    admin,
    client,
    yellow,
  },
});
